import { Button, type ButtonProps } from "antd";
import clsx from "clsx";
import "./BButton.scss";

const BButton = ({ className, ...props }: ButtonProps) => (
  <Button className={clsx("b-button", className)} {...props} />
);

export default BButton;
